import { TableCell, TableCellProps } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';

import { useCellStyles } from '../useCellStyles';


export function StickyTableCell({inHead, ...props}: TableCellProps & {inHead?: boolean}) {
  const classes = useCellStyles();
  const StyledCell = withStyles((theme) => ({
    head: {
      backgroundColor: '#e9ecef',
      color: '#6a757a',
      left: 0,
      position: 'sticky',
      zIndex: theme.zIndex.appBar + 2,
    },
    body: {
      backgroundColor: '#f7f7f7',
      left: 0,
      position: 'sticky',
      zIndex: theme.zIndex.appBar + 1,
    },
  }))(TableCell);

  return <StyledCell className={inHead ? classes.head : classes.cell}>{props.children}</StyledCell>;
}
